<template>
    <csv-upload-card :validator="contactCsvValidator" @selected="emit('selected', $event)">
        New contacts will be created. Phone numbers that match an existing contact will be updated with what you upload.
        Any conflicts with the subscription status or tags set above will be overridden by the CSV values.
    </csv-upload-card>
</template>

<script lang="ts" setup>
import CsvUploadCard from '~/components/general/CsvUploadCard.vue';
import { contactCsvValidator } from './validateCsvFile';

const emit = defineEmits<{
    selected: [file: File];
}>();
</script>
